// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2TNH1","loaderOuter":"PageOverlayLoader_loaderOuter__P9jXn"};